exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-335440d2]{font-size:12px}.errorStyle[data-v-335440d2]{font-weight:bolder;color:red}", ""]);

// exports
